<template>
  <v-main>
    <!-- / Mini Variant Sidebar -->
    <v-container fluid>
      <div class="dj-page-head">
        <div class="dj-page-head__text dj-page-head__row">
          <backbutton></backbutton>
          <h1 class="dj-page-title">{{ $route.query.type }} Modules</h1>
        </div>
        <div class="dj-page-actions">
          <v-btn
            fab
            small
            depressed
            color="primary"
            :to="`/modules/create?type=${$route.query.type}`"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </div>
      </div>
      <v-row>
        <v-col sm="4">
          <v-autocomplete
            ref="project"
            v-model="form.project_id"
            :items="projectItems"
            label="Select Project"
            prepend-inner-icon="mdi-ferry"
            @change="getData()"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="4">
          <v-autocomplete
            ref="category"
            v-model="form.category_id"
            :items="categoryItems"
            @change="getSubCategory(), getData()"
            label="Select Category"
            prepend-inner-icon="mdi-ferry"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="4" v-if="sub_categoryItems.length > 1">
          <v-autocomplete
            ref="sub_category"
            v-model="form.sub_category_id"
            :items="sub_categoryItems"
            @change="getData()"
            label="Select Sub Category"
            prepend-inner-icon="mdi-ferry"
            outlined
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Project</th>
                    <th class="text-left">Category</th>
                    <th class="text-left">Sub Category</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(module, i) in modules" :key="module.id">
                    <td>{{ i + 1 }}</td>
                    <td>{{ module.project.name }}</td>
                    <td>{{ module.category.name }}</td>
                    <td>{{ module.sub_category.description }}</td>
                    <!-- <td>{{ module.sub_category.details }}</td> -->
                    <td class="text-right">
                      <v-tooltip left v-if="module.module_jobs.length">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="primary"
                            icon
                            @click="showModuleTimeline(module)"
                          >
                            <v-icon>mdi-chart-timeline</v-icon>
                          </v-btn>
                        </template>
                        <span>Timeline</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-2"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="primary"
                            :to="`/module-jobs?module_id=${module.id}`"
                          >
                            <v-icon dark> mdi-eye </v-icon>
                          </v-btn>
                        </template>
                        <span>View Module Jobs</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-2"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="primary"
                            :to="`/modules/${module.id}`"
                          >
                            <v-icon dark> mdi-pencil </v-icon>
                          </v-btn>
                        </template>
                        <span>Edit Module</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- Module Job Timeline Pop UP  -->
      <v-dialog v-model="show_details" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>Module Timeline</h2>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_details = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-row>
              <v-simple-table fixed-header height="250px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th style="min-width: 120px">Name</th>
                      <th style="min-width: 120px">Workshop Name</th>
                      <th
                        style="min-width: 120px"
                        v-for="(date, d) in ModuleDetails.total_range"
                        :key="`date${d}`"
                      >
                        {{ date.date }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      dense
                      style="height: 25px"
                      v-for="(moduleJob, mj) in ModuleDetails.module_jobs"
                      :key="`moduleJob_${mj}`"
                    >
                      <td>{{ moduleJob.name }}</td>
                      <td>{{ moduleJob.workshop_name }}</td>
                      <!-- <td
                        v-for="(date, d) in moduleJob.dateRange"
                        :key="`date${d}`"
                        :style="`background-color: ${date.color}; height: 25px`"
                      ></td> -->
                      <td
                        v-for="(date, d) in ModuleDetails.total_range"
                        :key="`date${d}`"
                        :style="`background-color: ${
                          moduleJob.dateRange.find((md) => md.date == date.date)
                            ? moduleJob.dateRange.find(
                                (md) => md.date == date.date
                              ).color
                            : 'white'
                        }; height: 25px`"
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn text class="mr-2" @click="show_details = false"
                >Close
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / Module Job Timeline Pop UP -->
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
import moment from "moment";
export default {
  components: { backbutton },
  name: "ModulesPage",
  data() {
    return {
      form: {
        project_id: "",
        category_id: "",
        sub_category_id: "",
      },
      search_keyword: "",
      modules: [],
      show_details: false,
      ModuleDetails: [],
      projectItems: [{ id: 0, text: "Select Project", value: "0" }],
      categoryItems: [{ id: 0, text: "Select Category", value: "0" }],
      sub_categories: [],
      sub_categoryItems: [{ id: 0, text: "Select Sub Category", value: "0" }],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(
        `modules/masters?type=${this.$route.query.type}`
      );
      masters = masters.data;
      masters.projects.forEach((project) => {
        this.projectItems.push({
          id: project.id,
          text: project.name,
          value: project.id,
        });
      });
      masters.categories.forEach((category) => {
        this.categoryItems.push({
          id: category.id,
          text: category.name,
          value: category.id,
        });
        if (category.value_lists.length) {
          category.value_lists.forEach((sub_category) => {
            this.sub_categories.push(sub_category);
            this.sub_categoryItems.push({
              id: sub_category.id,
              text: sub_category.description,
              value: sub_category.id,
              value_id: sub_category.value_id,
            });
          });
        }
      });
      if (this.$route.query.project_id) {
        this.form.project_id = parseInt(this.$route.query.project_id);
      }
      if (this.$route.query.category_id) {
        this.form.category_id = this.$route.query.category_id;
      }
      if (this.$route.query.sub_category_id) {
        this.form.sub_category_id = this.$route.query.sub_category_id;
      }
      if (
        this.$route.query.project_id ||
        this.$route.query.category_id ||
        this.$route.query.sub_category_id
      ) {
        this.getData();
      }
    },
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let modules = [];
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&project_id=" +
        this.form.project_id +
        "&category_id=" +
        this.form.category_id +
        "&sub_category_id=" +
        this.form.sub_category_id;
      modules = await axios.get(`modules?${query}`);
      this.modules = modules.data.data;
      this.isLoading = false;
    },
    getSubCategory() {
      this.sub_categoryItems = [
        { id: 0, text: "Select Sub Category", value: "0" },
      ];
      this.sub_sub_categoryItems = [];
      this.form.sub_category_id = "";
      this.form.sub_sub_category_id = "";
      let sub_category = this.sub_categories.filter(
        (sub_category) => sub_category.value_id == this.form.category_id
      );

      sub_category.forEach((sc) => {
        this.sub_categoryItems.push({
          id: sc.id,
          text: sc.description,
          value: sc.id,
          value_id: sc.value_id,
        });
      });
    },
    showModuleTimeline(module) {
      this.show_details = true;
      if (module) {
        // If Module
        this.ModuleDetails = module;
        let total_array = [];
        this.ModuleDetails.module_jobs.forEach((moduleJob) => {
          // Make a Blank array of Estimate Start & End Date
          let array = [
            moduleJob.estimate_start_date,
            moduleJob.estimate_end_date,
          ];

          if (moduleJob.actual_start_date) {
            // If Actual star Date added
            array.push(moduleJob.actual_start_date);
          }
          if (moduleJob.actual_end_date) {
            array.push(moduleJob.actual_end_date);
          }
          array.sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          });
          let fromDate = moment(array[0]);
          let toDate = moment(array[array.length - 1]);

          let dateRange = [];
          while (fromDate <= toDate) {
            let ld = fromDate.format("YYYY-MM-DD");
            let date = {
              date: ld,
            };
            dateRange.push(date);
            fromDate = moment(fromDate).add(1, "days");
          }

          let estimate_date_range = [];
          let estimate_start_date = moment(moduleJob.estimate_start_date);
          let estimate_end_date = moment(moduleJob.estimate_end_date);
          while (estimate_start_date <= estimate_end_date) {
            let ld = estimate_start_date.format("YYYY-MM-DD");
            estimate_date_range.push(ld);
            estimate_start_date = moment(estimate_start_date).add(1, "days");
          }

          let actual_start_date = moment(moduleJob.actual_start_date);
          let actual_end_date = moment(moduleJob.actual_end_date);

          let actual_date_range = [];
          while (actual_start_date <= actual_end_date) {
            let ld = actual_start_date.format("YYYY-MM-DD");
            actual_date_range.push(ld);
            actual_start_date = moment(actual_start_date).add(1, "days");
          }

          dateRange.forEach((date) => {
            date.actual_exists = actual_date_range.some(function (actual_date) {
              return actual_date === date.date;
            });
            date.estimate_exists = estimate_date_range.some(function (
              estimate_date
            ) {
              return estimate_date === date.date;
            });

            if (
              date.estimate_exists == true &&
              moduleJob.actual_start_date == null
            ) {
              date.color = "yellow";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == false
            ) {
              date.color = "orange";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == true
            ) {
              date.color = "green";
            } else if (
              date.estimate_exists == false &&
              date.actual_exists == true
            ) {
              date.color = "red";
            } else {
              date.color = "white";
            }
          });
          moduleJob.dateRange = dateRange;
          total_array = total_array.concat(array);
        });
        total_array = [
          ...new Set(
            total_array.sort((a, b) => {
              if (a < b) return -1;
              if (a > b) return 1;
              return 0;
            })
          ),
        ];
        let t_fromDate = moment(total_array[0]);
        let t_toDate = moment(total_array[total_array.length - 1]);
        let total_range = [];
        while (t_fromDate <= t_toDate) {
          let ld = t_fromDate.format("YYYY-MM-DD");
          let date = {
            date: ld,
          };
          total_range.push(date);
          t_fromDate = moment(t_fromDate).add(1, "days");
        }
        this.ModuleDetails.total_range = total_range;
        console.log(this.ModuleDetails);
      }
    },
  },
};
</script>
